import './SlideList.scss';

import React from 'react';
import classNames from 'classnames';
import moment from 'moment';

import H4 from 'components/H4';
import Icon from 'components/Icon';
import LoadingSpinner from 'components/LoadingSpinner'

export default class SlideList extends React.Component {
    static propTypes = {
        bubbleCounts: React.PropTypes.array,
        className: React.PropTypes.string,
        count: React.PropTypes.oneOfType([React.PropTypes.number, React.PropTypes.string]),
        icon: React.PropTypes.string.isRequired,
        items: React.PropTypes.array.isRequired,
        onEditClick: React.PropTypes.func,
        showEditButton: React.PropTypes.bool,
        title: React.PropTypes.string.isRequired,
        type: React.PropTypes.string.isRequired,
        user: React.PropTypes.object
    };

    /**
     * @desc    Determines if an assignment is completed, and if it is, returns the completion date
     * @param   assignment (obj)
     * @returns {{completed: boolean, completionDate: number}}
     */
    assignmentCompletionData(assignment) {
        let data = {
            completed: false,
            completionDate: 0,
            lastAccessedDate: 0,
            visits: 0
        };

        let contentIdsArray = assignment.contents.map(content => content.id);

        assignment.contentUserStatuses.forEach((status) => {
            if(status.userId === this.props.user.id && status.visited === true) {
                data.visits += status.visits;
                if(status.completed === true) {
                    contentIdsArray.splice(contentIdsArray.indexOf(status.contentId), 1);
                    if(status.completionDate > data.completionDate) {
                        data.completionDate = status.completionDate;
                    }
                }

                //Store modified date for last accessed in case this isn't a completed assignment
                if(status.modified > data.lastAccessedDate) {
                    data.lastAccessedDate = status.modified;
                }
            }
        });

        if(contentIdsArray.length === 0) {
            if(assignment.requiresSignature === true) {
                assignment.userStatuses.forEach((status) => {
                    if(status.userId === this.props.user.id && status.signature != null) {
                        if(status.signature.created > data.completionDate) {
                            data.completionDate = status.signature.created;
                        }
                        data.completed = true;
                    }
                });
            } else {
                data.completed = true;
            }
        }

        return data;
    }

    /**
     * @desc    DOM manipulator --> Handles the click on a list title and
     *          opens and closes the list.
     * @param   event
     */
    openCloseList(event) {
        if(this.props.isFetching === true) {
            return;
        }
        let target = event.target;
        while(target.getAttribute('class') === null || target.getAttribute('class').indexOf('slide-list--wrapper') === -1) {
            target = target.parentNode;
        }
        let list = target.querySelector('.slide-list__list');
        if(target.classList.contains('open')) {
            list.style.height = '0';
            target.classList.remove('open');
        } else {
            list.style.height = target.querySelector('.slide-list__list--inner').offsetHeight + 'px';
            target.classList.add('open');
        }
    }

    render() {
        let { bubbleCounts, className, count, icon, isFetching, items, onEditClick, showEditButton, title, type } = this.props;

        return (
            <section className={className + ' slide-list--wrapper'}>
                <div className="slide-list__title" onClick={this.openCloseList.bind(this)}>
                    <Icon icon={icon} /> {title} {count != null ? ` (${count})` : null }
                    {bubbleCounts != null && bubbleCounts.map((bubble) => {
                        return (
                            <span className={`count-bubble count-bubble--${bubble.type}`}
                                  key={bubble.type}>
                                {bubble.count}
                            </span>
                        )
                    })}
                    {count > 0 && isFetching !== true ? (
                        <span className="slide-list__arrow"></span>
                    ) : null}
                    {isFetching === true ? (
                        <LoadingSpinner />
                    ) : null}
                    {showEditButton === true ? (
                        <div role="button"
                             className="slide-list__edit-button"
                             onClick={(event) => {
                                 event.stopPropagation();
                                 onEditClick.bind(this)()
                             }}>
                            Edit
                        </div>
                    ) : null}
                </div>
                <div className="slide-list__list">
                    <div className="slide-list__list--inner">
                        {items.map((item, index) => {
                            if(type === 'assignments') {
                                let completionData = this.assignmentCompletionData(item);
                                if(item.name.indexOf('Fourth') > 0) {
                                    console.log(item.name, completionData);
                                }
                                return (
                                    <div className={classNames('slide-list__item', 'slide-list__item--assignment', {'completed': completionData.completed === true})}
                                         key={item.id || index} data-id={item.id}>
                                        <H4 className="slide-list__item-name">
                                            {completionData.completed === true ? (
                                                <Icon icon="check" />
                                            ) : null}
                                            {item.name}
                                        </H4>
                                        <div className="slide-list__data-point">
                                            Content Visit Count: {completionData.visits}
                                        </div>
                                        {completionData.completed === true ? (
                                            <div className="slide-list__data-point">
                                                Completed: {`${moment(completionData.completionDate).format('MM/DD/YY')} at ${moment(completionData.completionDate).format('h:mma')}`}
                                            </div>
                                        ) : (
                                            <div className="slide-list__data-point">
                                                Last Accessed: {completionData.lastAccessedDate !== 0 ? `${moment(completionData.lastAccessedDate).format('MM/DD/YY')} at ${moment(completionData.lastAccessedDate).format('h:mma')}` : '--'}
                                            </div>
                                        )}
                                    </div>
                                );
                            } else if(type === 'assignments--names-only') {
                                return (
                                    <div className="slide-list__item slide-list__item--assignments--names-only" key={item.id || index}>
                                        {item.name}
                                    </div>
                                );
                            } else if(type === 'groups') {
                                return (
                                    <div className="slide-list__item slide-list__item--group" key={item.id || index}>
                                        {item.name}
                                    </div>
                                );
                            } else if(type === 'users') {
                                return (
                                    <div className="slide-list__item slide-list__item--user" key={item.id || index}>
                                        {item.firstName} {item.lastName}
                                    </div>
                                );
                            } else {
                                return null;
                            }
                        })}
                    </div>
                </div>
            </section>
        );

    }
}



// WEBPACK FOOTER //
// ./src/components/SlideList/index.js